import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';
import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';
import WorkerDto from '@/models/Workers/WorkerDto';

export default class SpecOutDto extends BaseAgencyScopeEntityDto {
    status: SpecOutStatus = SpecOutStatus.Draft;
    branchId = '';
    branch: BranchDto = new BranchDto();
    deskId = '';
    desk: DeskDto = null;
    ownerId = '';
    owner: AgencyUserDto = new AgencyUserDto();
    emailTemplateId = '';
    emailTemplate: EmailTemplateDto = null;
    emailBccUser = true;
    isTest = false;
    testEmailAddresses = '';
    sentAt: Date = null;
    workerId = '';
    worker: WorkerDto = null;
}
